import {createContext, useContext} from 'react';

export interface ProcedureRunDesignFlowchartAddReplicateContextValue {
  /** Adds a new condition-replicate lane (a draft group covering the active + downstream methods). */
  onAdd: () => void;
}

/**
 * Add-replicate wiring for the flowchart button node. Threaded via context (rather than node `data`) so
 * the callback can change without re-triggering layout. Defaults to a no-op so any render outside the
 * editor stays inert.
 */
export const ProcedureRunDesignFlowchartAddReplicateContext =
  createContext<ProcedureRunDesignFlowchartAddReplicateContextValue>({
    onAdd: () => {},
  });

/** Reads the add-replicate callback for the flowchart button node. */
export function useProcedureRunDesignFlowchartAddReplicate(): ProcedureRunDesignFlowchartAddReplicateContextValue {
  return useContext(ProcedureRunDesignFlowchartAddReplicateContext);
}
